/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-17 04:05 pm
 * Last Modified: Tuesday, 25-05-20 06:17 pm, by Ben Zhao
 */

import type { BoxProps } from '@mui/material';
import { Box, Stack } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import type { ButtonGroupProps } from '@/components/ButtonGroup';
import ButtonGroup from '@/components/ButtonGroup';
import { NavBar } from '../NavBar';
import XBreadcrumbs from '../XBreadcrumbs';
import { ContentContainer } from './style';
export interface ContentBoxProps extends BoxProps {
  buttonGroup?: ButtonGroupProps;
  showNav?: boolean;
  hideBreadcrumb?: boolean;
  contentSx?: BoxProps['sx'];
  outerSx?: BoxProps['sx'];
}
export default function ContentBox({
  children,
  buttonGroup,
  showNav,
  hideBreadcrumb,
  contentSx = {},
  outerSx,
  ...props
}: ContentBoxProps) {
  if (showNav) {
    return <ContentContainer component="main" sx={contentSx}>
        <Box height="100%" overflow="auto" padding="20px 0 108px 0" pb={{
        xs: '115px',
        sm: '108px'
      }} width="100%" {...props}>
          {children}
        </Box>

        <NavBar />
      </ContentContainer>;
  }
  return <ContentContainer component="main" sx={contentSx} data-sentry-element="ContentContainer" data-sentry-component="ContentBox" data-sentry-source-file="index.tsx">
      {!hideBreadcrumb && <XBreadcrumbs />}
      <Stack height="100%" overflow="auto" pb={{
      xs: '34px',
      sm: '0'
    }} sx={outerSx} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Flex flex={1} flexDirection="column" width="100%" {...props} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          {children}
        </Flex>

        {buttonGroup && <ButtonGroup p="0 20px 20px 20px" pb={{
        xs: '16px',
        sm: '20px'
      }} {...buttonGroup} />}
      </Stack>
    </ContentContainer>;
}